import { useEffect, useState } from "react";
import useAuth from "../hook/useAuth";
import { getUserProgress } from "../services/Progress";

type UserProgressProps = {
  refresh?: boolean
}

export const UserProgress = ({ refresh = true }: UserProgressProps) => {
  const { auth }: any = useAuth();
  const [userProgress, setUserProgress] = useState<any>({});
  const [progressDataIsLoaded, setProgressDataIsLoaded] = useState<boolean>(false);

  useEffect(() => {
    if (auth?.id && refresh) {
      setProgressDataIsLoaded(false);
      getUserProgress(auth?.id)
        .then((data) => {
          setUserProgress(data);
          setProgressDataIsLoaded(true);
        })
        .catch((error) => {
          console.error(error)
        })
    }

  }, [auth, refresh])

  return (
    <div className="w-full rounded-md p-3 flex items-center justify-between">
      {
        progressDataIsLoaded && (
          <>
            <span className="text-gray-800 text-lg font-semibold block max-md:hidden">Keep going! Complete all courses to level up your learning. 🚀</span>
            <div className="w-full max-w-sm">
              {/* Header */}
              <div className="flex items-center justify-between mb-2 text-sm font-medium text-gray-700">
                <div className="flex items-center gap-1">
                  <span>Courses Progress</span>
                  <div className="relative group inline-block">
                    <span
                      className="w-4 h-4 flex justify-center items-center rounded-full bg-gray-200 text-gray-600 text-xs cursor-pointer"
                    >
                      i
                    </span>

                    <div
                      className="
                                  absolute hidden group-hover:block z-50
                                  sm:group-hover:block
                                  mt-2 w-48 text-xs
                                  bg-white text-gray-600 p-2 rounded shadow-lg
                                "
                    >
                      This shows your progress in compare of your all enrolled courses.
                    </div>
                  </div>

                </div>
                <span>{userProgress?.progressValue} / {userProgress?.totalValue}</span>
              </div>

              {/* Progress Bar */}
              <div className="w-full h-2 bg-gray-200 rounded-full mb-2 relative group cursor-pointer">
                <div
                  className="h-2 bg-blue-500 rounded-full transition-all duration-500"
                  style={{ width: `${userProgress?.percentage}%` }}
                />
                <div className="
        absolute left-1/2 -translate-x-1/2
        bottom-full mb-2
        w-max
        max-w-[200px]
        bg-gray-900 text-white text-xs
        px-2 py-1 rounded
        opacity-0 group-hover:opacity-100
        pointer-events-none
        transition-opacity
        z-50
      ">
                  Attempted: {`${userProgress?.percentage}%`}
                </div>
              </div>

            </div>
          </>
        )
      }

    </div>

  )
}